/** @format */
/** @format */

import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  Button,
  Select,
  Option,
  Icon,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Message
} from '@king-design/react'
import { MonitorSearch } from 'src/components'
import { PrometheusAlarmTabProps } from 'src/pages/PrometheusMonitor/Alarm'
import { PageProps, initPage } from 'src/utils/interface'
import { useHistory } from 'react-router-dom'
import { useAsyncFn } from 'react-use'
import {
  getPrometheusAlertTemplateList,
  deletePrometheusAlertTemplate
} from 'src/api/ApiPrometheusAlarm'
export const TemplateTypeEnum = {
  0: '全部',
  1: '系统模板',
  2: '自定义模板'
}
interface SearchProps extends PageProps {
  Name: string
  Type: 0 | 1 | 2
}

const initSearch: SearchProps = {
  Name: '',
  Type: 0,
  ...initPage
}

const PrometheusAlarmTemplate: FC<PrometheusAlarmTabProps> = ({ className }) => {
  const history = useHistory()
  const [search, setSearch] = useState<SearchProps>(initSearch)

  const [{ value: tableData }, fetch] = useAsyncFn(
    async (params?) => {
      const result = await getPrometheusAlertTemplateList({
        ...search,
        ...params
      })
      return {
        data: result?.AlertTemplates || [],
        total: result?.TotalCount || 0
      }
    },
    [search]
  )

  useEffect(() => {
    fetch()
  }, [search])

  // 删除模板
  const [, deleteFetch] = useAsyncFn(async TemplateID => {
    const result = await deletePrometheusAlertTemplate({
      TemplateID
    })
    if (result?.code === 'Success') {
      Message.success('删除成功')
      setSearch({
        ...search,
        Page: 1
      })
    } else {
      result?.message && Message.error(result?.message)
    }
  }, [])

  return (
    <div className={className}>
      <div className="header">
        <Button
          type="primary"
          onClick={() => {
            history.push(`/monitor/prometheusmonitor/alarm/edit?page=template&tab=template`)
          }}
        >
          <Icon className="ion-plus-round" />
          新建告警模板
        </Button>
      </div>
      <div className="search_row">
        <div className="search_item">
          <p className="search_item_label">模板类型</p>
          <Select
            value={search.Type}
            clearable
            onChangeValue={value => {
              setSearch({
                ...search,
                Page: 1,
                Type: value
              })
            }}
          >
            {Object.keys(TemplateTypeEnum).map(key => (
              <Option key={key} value={Number(key)}>
                {TemplateTypeEnum[key]}
              </Option>
            ))}
          </Select>
        </div>
        <div className="search_item">
          <p className="search_item_label">模板名称</p>
          <MonitorSearch
            placeholder="请输入模板名称，支持模糊搜索"
            onChange={value => {
              setSearch({
                ...search,
                Page: 1,
                Name: value
              })
            }}
          />
        </div>
      </div>
      <Table
        data={tableData?.data || []}
        animation={false}
        rowKey={data => data.ID}
        checkType="none"
      >
        <TableColumn
          key="Name"
          title="模板名称"
          slotTemplate={([data]) => {
            return (
              <a
                onClick={() => {
                  if (!data.ID === undefined) {
                    Message.error('模板ID为空')
                    return
                  }
                  history.push(
                    data.Type === 2
                      ? // eslint-disable-next-line max-len
                        `/monitor/prometheusmonitor/alarm/edit?page=template&templateid=${data.ID}&tab=template`
                      : // eslint-disable-next-line max-len
                        `/monitor/prometheusmonitor/alarm/view?templateid=${data.ID}&tab=template`
                  )
                }}
              >
                {data.Name}
              </a>
            )
          }}
        />
        <TableColumn
          key="Type"
          title="类型"
          slotTemplate={([data]) => {
            return TemplateTypeEnum[data.Type] || '未知类型'
          }}
        ></TableColumn>
        <TableColumn
          key="operate"
          title="操作"
          width="80"
          slotTemplate={([data]) => {
            return data.Type === 2 ? (
              <a
                onClick={() => {
                  let dialog: Dialog
                  Dialog.confirm({
                    title: '是否确认该告警模板？',
                    ref: _dialog => (dialog = _dialog),
                    okText: '确认删除',
                    ok: async () => {
                      dialog.showLoading()
                      await deleteFetch(data.ID)
                      dialog.close()
                    }
                  })
                }}
              >
                删除
              </a>
            ) : (
              '-'
            )
          }}
        ></TableColumn>
      </Table>
      <Pagination
        value={search.Page}
        limit={search.PageSize}
        total={tableData?.total || 0}
        size="small"
        onChangeValue={value => {
          setSearch({
            ...search,
            Page: value
          })
        }}
        onChangeLimit={limit => {
          setSearch({
            ...search,
            PageSize: limit
          })
        }}
      />
    </div>
  )
}

export default styled(PrometheusAlarmTemplate)`
  .k-table {
    .table_status {
      b {
        margin: 0 4px;
      }
    }
  }
`
